import { render, staticRenderFns } from "./LootArmor.vue?vue&type=template&id=3b9019b0&lang=pug&"
import script from "./LootArmor.vue?vue&type=script&lang=ts&"
export * from "./LootArmor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports